import gsap from 'gsap';

export const animatePageIn = (element: string) =>
  gsap.timeline().from(element, { opacity: 0, delay: 0.1, duration: 0.75 });
